
import CreateMusicViewModel from "@models/music/createMusicViewModel";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class AudioGroupBlockComponent extends Vue {  
  @Prop({type: String, required: true}) url: string;
  @Prop({type: String}) label: string;
  @Prop({type: String, required: true}) name: string;
  @Prop({type: Object}) audio: CreateMusicViewModel;
  @Prop({type: Boolean, default: false}) editBtn: boolean;
  startEdit() {
    this.$emit('edit', this.audio);
  }
  startDelete() {
    this.$emit('delete', this.audio);
  }
}
